// app/frontend/components/EventForm/sections/EventFormButtons.tsx
import { Button, Group } from '@mantine/core';
import { EventFormButtonsProps } from '../types';

const EventFormButtons: React.FC<EventFormButtonsProps> = ({ form, isLoading, onSubmit }) => {
  return (
    <Group mt="xl">
      <Button
        variant="outline"
        size="lg"
        fullWidth
        color="gray"
        loading={isLoading}
        onClick={() => onSubmit('draft')} // Pass form.values and submit type
      >
        Save as Draft
      </Button>

      <Button
        type="button"
        size="lg"
        fullWidth
        color="#EA580C"
        loading={isLoading}
        onClick={() => onSubmit('publish')} // Pass form.values and submit type
      >
        {form.values.is_recurring === 'true' ? 'Submit Recurring Event For Approval' : 'Submit Event For Approval'}
      </Button>
    </Group>
  );
};

export default EventFormButtons;
